[
  {
    "ID": "1",
    "title": "EZ Texting (Pilot)",
    "description": "Use Campanion to sync your contacts with EZ Texting.",
    "managementUrl": "/integrations/eztexting",
    "connectionFlag": "texting-enabled",
    "logo": "eztexting_logo.png",
    "outreach": "Contact a CampMinder team member to learn more about our pilot program."
  }
]
